export default {
    getMycars (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/car/list',{params:params})
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getBrands () {
        return new Promise((resolve, reject) => {
            axios.get('/api/car/brands')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getCars (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/car/cars',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getGene (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/car/generations',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getModels (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/car/models',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    uploadImg (params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/upload',params,{
                headers:{'Content-Type':'multipart/form-data'}
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    addInfo(params){
     return new Promise((resolve, reject) => {
        axios.post('/api/car/add',params)
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
 },
 updateInfo(id,params){
     return new Promise((resolve, reject) => {
        axios.put('/api/car/'+id+'/update',params)
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
 },
 delCar(carid){
     return new Promise((resolve, reject) => {
        axios.delete('/api/car/'+ carid +'/delete')
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    }) 
 },
 getCarinfo(id){
     return new Promise((resolve, reject) => {
        axios.get('/api/car/'+ id)
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })  
 },
 chooseDefault(id){
     return new Promise((resolve, reject) => {
        axios.put('/api/car/'+ id+ '/default')
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })  
 }
}